<template>
  <div class="big shopExchange-set">
    <div class="page_title flex_between">
      <span>商品兑换配置</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 商品名称 -->
            <div class="item">
              <span>商品名称</span>
              <div class="item-content">
                <el-input
                  v-model="searchForm.goods_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
            <!-- 状态 -->
            <div class="item">
              <span>状态</span>
              <div class="item-content">
                <el-select
                  v-model="searchForm.status"
                  size="small"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="出售中" :value="1"> </el-option>
                  <el-option label="未上架" :value="2"> </el-option>
                  <el-option label="回收站" :value="3"> </el-option>
                </el-select>
              </div>
            </div>
            <!-- 医生端是否展示 -->
            <div class="item">
              <span>医生端是否展示</span>
              <div class="item-content">
                <el-radio-group
                  v-model="searchForm.is_doctor_show"
                  style="padding-top: 4px"
                >
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
            </div>
          </div>
          <!-- 添加商品 -->
          <div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="addGoods"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2014') : false
              "
              >增加商品</el-button
            >
            <el-button
              type="danger"
              size="small"
              style="margin-left: 10px"
              @click="batchDelete"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2015') : false
              "
              >批量删除</el-button
            >
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2065') : false
              "
              @click="exportData"
              >导出</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleMainSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'sort'">
                  <el-input-number
                    v-model="scope.row.sort"
                    size="medium"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 90px"
                    @change="updateSort(scope.row)"
                  ></el-input-number>
                </div>

                <div v-else-if="item.prop == 'goods_name'">
                  <div style="width: 300px">
                    <el-image
                      :src="scope.row.picture_str"
                      :preview-src-list="[scope.row.picture_str]"
                      style="width: 100px; height: 100px"
                    />
                  </div>
                  <div>{{ scope.row.goods_name }}</div>
                </div>

                <div v-else-if="item.prop == 'sku_name_str'">
                  <div v-if="scope.row.open_spec == 1">
                    {{ scope.row.sku_name_str }}
                  </div>
                  <div v-else>无</div>
                </div>

                <div v-else-if="item.prop == 'price'">
                  {{ scope.row | priceText }}
                </div>
                <div v-else-if="item.prop == 'status'">
                  {{ scope.row.status | statusText }}
                </div>

                <div v-else-if="item.prop == 'is_doctor_show'">
                  <el-switch
                    v-model="scope.row.is_doctor_show"
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('2034')
                        : false
                    "
                    @change="changeDoctorShow(scope.row)"
                  >
                  </el-switch>
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row.create_time | dateFormatHS }}
                </div>

                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="140"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="delBtn(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('2015')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 选择活动商品（内置） -->
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodDia"
      width="1000px"
      style="text-align: left"
      :close-on-click-modal="false"
      append-to-body
      class="big"
    >
      <div class="content">
        <div style="padding: 20px">
          <span>商品：</span>
          <el-input
            v-model="goodsKeywords"
            placeholder="请输入商品"
            size="small"
            maxlength="20"
            style="width: 200px"
          ></el-input>
          <span style="margin-left: 20px">商品活动类型：</span>
          <el-select v-model="act_type_id"     size="small" clearable placeholder="请选择">
            <el-option
              v-for="item in actTypeOptions"
              :key="item.act_type_id"
              :label="item.act_type_name"
              :value="item.act_type_id"
            >
            </el-option>
          </el-select>
          <span style="margin-left: 20px">是否参加商城活动：</span>
          <el-radio-group v-model="goodsIsActivity" size="small">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="'1'">是</el-radio>
            <el-radio :label="'0'">否</el-radio>
          </el-radio-group>
          <el-button
            type="primary"
            @click="getGoodsList"
            size="small"
            style="margin-left: 20px"
            >查询</el-button
          >
        </div>

        <div class="table_list">
          <el-table
            ref="goodsTableRef"
            :data="goodsList"
            v-loading="goodsLoading"
            tooltip-effect="dark"
            height="400"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleGoodsSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="商品" width="300">
              <template slot-scope="scope">
                <div class="flex between" style="width: 300px">
                  <el-image
                    :src="scope.row.picture"
                    :preview-src-list="[scope.row.picture]"
                    style="width: 100px; height: 100px"
                  />
                  <div style="width: 180px">
                    <div>{{ scope.row.goods_name }}</div>
                    <div v-if="scope.row.category_label">
                      <el-tag type="danger">{{
                        scope.row.category_label
                      }}</el-tag>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="商品价格" width="140">
              <template slot-scope="scope">
                {{ scope.row | priceListText }}
              </template>
            </el-table-column>
            <el-table-column prop="stock" label="库存" />
            <el-table-column
              prop="is_activity"
              label="是否参加商城活动"
              width="160"
            >
              <template slot-scope="scope">
                {{ scope.row.is_activity == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="act_type_name"
              label="商品活动类型"
              width="160"
            >
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <pagination
            v-show="goodsTotal > 0"
            :total="goodsTotal"
            :page.sync="goodsPagination.page"
            :limit.sync="goodsPagination.pageNumber"
            @pagination="getGoodsList"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseGoodDia = false" plain>取 消</el-button>
        <el-button type="primary" @click="submitChooseGoods">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import common from "@/api/common.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      chooseGoodDia: false,
      searchForm: {
        goods_name: "",
        is_doctor_show: "",
        status: "",
      },
      // 选择商品对话框数据
      goodsKeywords: "",
      goodsIsActivity: "",
      act_type_id: "",
      goodsList: [],
      goodsSelection: [],
      goodsLoading: false,
      goodsTotal: 0,
      goodsPagination: {
        page: 1,
        pageNumber: 10,
      },

      tableHeader: [
        {
          label: "排序",
          prop: "sort",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "商品",
          prop: "goods_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "规格",
          prop: "sku_name_str",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "价格",
          prop: "price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生端是否展示",
          prop: "is_doctor_show",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "添加时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "兑换数量",
          prop: "exchange_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      mainSelection: [],
      actTypeOptions: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateFormatHS(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    priceText(val) {
      if (!val.sku_item.length) {
        return val.price;
      } else if (val.sku_max_price == val.sku_min_price) {
        return val.sku_min_price;
      } else {
        return `${val.sku_min_price} - ${val.sku_max_price}`;
      }
    },
    priceListText(val) {
      if (!val.sku_list.length) {
        return val.price;
      } else if (val.sku_max_price == val.sku_min_price) {
        return val.sku_min_price;
      } else {
        return `${val.sku_min_price} - ${val.sku_max_price}`;
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "出售中";
        case 2:
          return "未上架";
        case 3:
          return "回收站";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取商品活动类型
    getActTypeOptions() {
      common.goodsActType().then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.actTypeOptions = data.list || [];
        }
      });
    },
    async addGoods() {
      this.chooseGoodDia = true;
      // 重置分页和选择状态
      this.goodsPagination = { page: 1, pageNumber: 10 };
      this.goodsSelection = [];
      this.goodsKeywords = "";
      this.goodsIsActivity = "";
      this.act_type_id = "";
      await this.getActTypeOptions();
      this.getGoodsList();
    },
    checkGoods(data) {
      if (!data.length) {
        this.$message.warning("请选择商品");
        return;
      }
      marketing.addHeartActivityGoods({ goods_list: data }).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("添加成功");
          this.getList();
        }
      });
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      this.tableLoading = true;
      marketing.heartActivityGoodsList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          let list = data.list.map((item) => {
            if (item.sku_item.length) {
              let sku_name_arr = item.sku_item.map((item) => item.sku_name);
              item.sku_name_str = sku_name_arr.join("；");
            }
            return item;
          });
          this.tableData = list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 删除
    delBtn(row) {
      this.$confirm("确认删除当前商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          marketing.delHeartActivityGoods({ id: row.id }).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("删除成功");
              this.getList();
            }
          });
        })
        .catch((err) => {});
    },
    // 排序
    updateSort(row) {
      let { id, sort } = row;
      marketing.updateHeartActivityGoodsSort({ id, sort }).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("操作成功");
          this.getList();
        }
      });
    },
    // 医生端是否展示切换
    changeDoctorShow(row) {
      let { id, is_doctor_show } = row;
      marketing.updateActivityDoctorShow({ id, is_doctor_show }).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("操作成功");
          this.getList();
        }
      });
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 主表格多选
    handleMainSelectionChange(val) {
      this.mainSelection = val;
    },
    // 批量删除
    batchDelete() {
      if (!this.mainSelection.length) {
        this.$message.warning("请选择商品");
        return;
      }
      this.$confirm("确认删除所选商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const requests = this.mainSelection.map((row) =>
            marketing.delHeartActivityGoods({ id: row.id })
          );
          Promise.all(requests).then(() => {
            this.$message.success("删除成功");
            this.getList();
            this.mainSelection = [];
          });
        })
        .catch(() => {});
    },
    // 获取商品列表
    getGoodsList() {
      this.goodsLoading = true;
      let params = {
        type: 6, // 固定传6商品兑换配置
        is_activity: this.goodsIsActivity,
        act_type_id: this.act_type_id,
        keywords: this.goodsKeywords,
        page: this.goodsPagination.page,
        pageNumber: this.goodsPagination.pageNumber,
      };
      marketing
        .getShopActivityGoodsList(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.goodsList = data.list || [];
            this.goodsTotal = data.total || 0;
          } else if (res.data && res.data.list) {
            // 兼容旧返回结构
            this.goodsList = res.data.list;
            this.goodsTotal = res.data.total || 0;
          }
        })
        .finally(() => (this.goodsLoading = false));
    },
    handleGoodsSelectionChange(val) {
      this.goodsSelection = val;
    },
    submitChooseGoods() {
      if (!this.goodsSelection.length) {
        this.$message.warning("请选择商品");
        return;
      }
      // 调用原有的checkGoods方法处理选中的商品
      this.checkGoods(this.goodsSelection);
      this.chooseGoodDia = false;
    },
    // 导出
    exportData() {
      const loading = this.$loading();
      let params = {
        goods_name: this.searchForm.goods_name || "",
        is_doctor_show:
          this.searchForm.is_doctor_show !== ""
            ? this.searchForm.is_doctor_show
            : "",
        status: this.searchForm.status || "",
      };
      marketing
        .heartActivityGoodsListExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
            this.$message.success("导出成功");
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.shopExchange-set {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      margin-right: 16px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
